import React from "react";
import { Grid, makeStyles, TextField } from "@material-ui/core";
import { KeyboardDatePicker } from "@material-ui/pickers";
import { useIncidentDetails } from "../../contexts/IncidentContext";
import { incidentTypeList } from "../../constants/incidentType";
import ResponsiveSelect from "../../../components/ui/ResponsiveSelect";

const useStyles = makeStyles(() => ({
  datePicker: {
    margin: 0,
  },
}));

const maximumDate = new Date().setHours(23, 59, 59);

function IncidentDetailsForm() {
  const classes = useStyles();
  const {
    incidentType,
    setIncidentType,
    incidentDate,
    setIncidentDate,
    incidentDescription,
    setIncidentDescription,
  } = useIncidentDetails();
    
  return (
    <Grid container spacing={2}>
      <Grid item xs={12} md={6}>
        <KeyboardDatePicker
          required
          className={classes.datePicker}
          format="dd/MM/yyyy"
          fullWidth
          label="Incident date"
          inputVariant="outlined"
          value={incidentDate}
          onChange={setIncidentDate}
          maxDate={maximumDate}
          maxDateMessage={"Incident date must be in the past."}
        />
      </Grid>
      <Grid item xs={12} md={6}>
        <ResponsiveSelect
          required
          fullWidth
          label="Incident type"
          options={incidentTypeList}
          optionValueKey="value"
          optionLabelKey="label"
          value={incidentType}
          onChange={(e) => setIncidentType(e.target.value)}
        />
      </Grid>
      <Grid item xs={12}>
        <TextField
          required
          variant="outlined"
          fullWidth
          label="Description"
          value={incidentDescription || ""}
          onChange={(e) => setIncidentDescription(e.target.value)}
        />
      </Grid>
    </Grid>
  );
}

export default IncidentDetailsForm;
